import { render } from "./ContactTile.vue?vue&type=template&id=0438685e&scoped=true"
import script from "./ContactTile.vue?vue&type=script&lang=ts"
export * from "./ContactTile.vue?vue&type=script&lang=ts"

import "./ContactTile.vue?vue&type=style&index=0&id=0438685e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0438685e"

export default script